module.exports = __webpack_public_path__ + "img/ALERT_icon.32bae240.svg";